<template>
  <div class="">
    <div class="guahaopage1">
      <div class="x-wrap m-main">
      </div>
      <div class="guahao5page1">
        <div class="x-wrap m-main clear">
          <div class="leftbox mCustomScrollbar _mCS_1">
            <div
              id="mCSB_1"
              class="mCustomScrollBox mCS-light mCSB_vertical mCSB_inside"
              style="max-height: none;"
              tabindex="0"
            >
              <div
                id="mCSB_1_container"
                class="mCSB_container"
                style="position:relative; top:0; left:0;"
                dir="ltr"
              >
                <div class="list">
                  <div @click="tabClick(1)" class="a1 item now">
                    <div class="li">
                      <br />
                      <a>APP预约</a>
                    </div>
                  </div>
                  <div @click="tabClick(2)" class="a2 item ">
                    <div class="li">
                      <br />
                      <a>1.添加就诊人</a>
                    </div>
                  </div>
                  <div @click="tabClick(3)" class="a3 item ">
                    <div class="li">
                      <br />
                      <a>2.进入预约界面</a>
                    </div>
                  </div>
                  <div @click="tabClick(4)" class="a4 item ">
                    <div class="li">
                      <br />
                      <a>3.预约流程</a>
                    </div>
                  </div>
                  <div @click="tabClick(5)" class="a5 item ">
                    <div class="li">
                      <br />
                      <a>4.预约确认及支付</a>
                    </div>
                  </div>
                  <div @click="tabClick(6)" class="a6 item ">
                    <div class="li">
                      <br />
                      <a>5.取消预约</a>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="mCSB_1_scrollbar_vertical"
                class="mCSB_scrollTools mCSB_1_scrollbar mCS-light mCSB_scrollTools_vertical"
                style="display: none;"
              >
                <div class="mCSB_draggerContainer">
                  <div
                    id="mCSB_1_dragger_vertical"
                    class="mCSB_dragger"
                    style="position: absolute; min-height: 30px; display: block; height: 367px; max-height: 380px; top: 0px;"
                  >
                    <div
                      class="mCSB_dragger_bar"
                      style="line-height: 30px;"
                    ></div>
                  </div>
                  <div class="mCSB_draggerRail"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="rightbox">
            <div v-if="radioValue == 1" class="inner">
              <div class="box2">
                <div class="tit2">
                  <span class="s1">APP预约</span>
                </div>
                <div class="content">
                  <p>
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      >客户可直接下载京东方医院APP，完成个人信息登录注册，输入就诊人信息即可完成相应的门诊及体检预约。</span
                    >
                  </p>
                  <p>
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      >APP下载地址：</span
                    >
                  </p>
                  <p style="text-align:center;">
                    <img
                      src="../images/u5e6dd2d3f1a10.png"
                      width="300"
                      height="390"
                      title="from clipboard"
                      alt="from clipboard"
                    />
                  </p>
                </div>
              </div>
            </div>
            <div v-if="radioValue == 2" class="inner">
              <div class="box2">
                <div class="tit2">
                  <span class="s1">1.添加就诊人</span>
                </div>
                <div class="content">
                  <p class="MsoNormal" style="text-align:left;">
                    <span
                      style="font-size:16px;font-family:Arial;line-height:2;color:#000000;"
                      >通过“首页-就诊服务-服务-就诊人管理”路径进入就诊人管理页面</span
                    >
                  </p>
                  <p class="MsoNormal" style="text-align:left;">
                    <span
                      style="font-size:16px;font-family:Arial;line-height:2;"
                      ><br />
                    </span>
                  </p>
                  <p class="MsoNormal" style="text-align:center;">
                    <img
                      src="../images/hf-app-1.png"
                      alt=""
                    />
                  </p>
                  <p class="MsoNormal" style="text-align:left;">
                    <br />
                  </p>
                  <p class="MsoNormal" style="text-align:left;">
                    <span
                      style="font-size:16px;font-family:Arial;line-height:2;color:#000000;"
                      >点击“添加就诊人”按钮，按要求完成填写</span
                    >
                  </p>
                  <p class="MsoNormal" style="text-align:left;">
                    <span
                      style="font-size:16px;font-family:Arial;line-height:2;"
                      ><br />
                    </span>
                  </p>
                  <p class="MsoNormal" style="text-align:center;">
                    <img
                      src="../images/u5e706f0bc7f30.png"
                      alt=""
                    />
                  </p>
                  <p class="MsoNormal" style="text-align:left;">
                    <br />
                  </p>
                  <p class="MsoNormal" style="text-align:left;">
                    <span
                      style="font-size:16px;font-family:Arial;line-height:2;color:#000000;"
                      >点击“保存”</span
                    >
                  </p>
                </div>
              </div>
            </div>
            <div v-if="radioValue == 3" class="inner">
              <div class="box2">
                <div class="tit2">
                  <span class="s1">2.进入预约界面</span>
                </div>
                <div class="content">
                  <p class="MsoNormal">
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      >路径1：通过“首页-我要就诊”路径进入预约界面，点击“开始就诊”按钮</span
                    >
                  </p>
                  <p class="MsoNormal">
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      >路径2：通过“首页-就诊服务-就诊”路径进入就诊任务面板，如果是首次进入，可直接点击“我要就诊”按钮；如果同时存在多个就诊流程，可直接点击已有流程进入或点击“添加就诊”按钮新建预约</span
                    >
                  </p>
                  <p class="MsoNormal">
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;"
                      ><br />
                    </span>
                  </p>
                  <p class="MsoNormal" style="text-align:center;">
                    <img
                      src="../images/u5e706f62d1faf.png"
                      alt=""
                    /><span style="line-height:2;"></span>
                  </p>
                  <p class="MsoNormal">
                    <span style="line-height:2;"><br /> </span>
                  </p>
                  <p class="MsoNormal">
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      >路径3：通过“首页-就诊服务-服务-预约挂号”路径进入预约界面</span
                    >
                  </p>
                  <p class="MsoNormal">
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      ><br />
                    </span>
                  </p>
                  <p class="MsoNormal" style="text-align:center;">
                    <img
                      src="../images/u5e706f843525a.png"
                      alt=""
                    />
                  </p>
                </div>
              </div>
            </div>
            <div v-if="radioValue == 4" class="inner">
              <div class="box2">
                <div class="tit2">
                  <span class="s1">3.预约流程</span>
                </div>
                <div class="content">
                  <p class="MsoNormal">
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      >点击确认同意“门诊常规同意书”，如您不同意无法继续后续挂号流程</span
                    >
                  </p>
                  <p class="MsoNormal">
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      >在“选择科室”界面点击想要就诊的科室，如您不知道如何选择，可咨询医务人员或使用APP中“智能分诊”功能，进行初步分诊</span
                    >
                  </p>
                  <p class="MsoNormal">
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      >按时间预约：点击预约日期-选择挂号医生-选择挂号时段-点击下一步</span
                    >
                  </p>
                  <p class="MsoNormal">
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      ><br />
                    </span>
                  </p>
                  <p class="MsoNormal" style="text-align:center;">
                    <img
                      src="../images/u5e7070027341b.png"
                      alt=""
                    />
                  </p>
                  <p class="MsoNormal">
                    <br />
                  </p>
                  <p class="MsoNormal">
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      >按专家预约：点击按专家预约-选择挂号医生-选择可预约的就诊日期-选择挂号时段-点击下一步</span
                    >
                  </p>
                  <p class="MsoNormal">
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      ><br />
                    </span>
                  </p>
                  <p class="MsoNormal" style="text-align:center;">
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      ><img
                        src="../images/u5e70701af2447.png"
                        alt=""
                      /><br />
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div v-if="radioValue == 5" class="inner">
              <div class="box2">
                <div class="tit2">
                  <span class="s1">4.预约确认及支付</span>
                </div>
                <div class="content">
                  <p class="MsoNormal">
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      >在“预约信息”界面，确认预约基本信息，如此时想更换就诊人，可点击“选择就诊人”按钮进行更换；如之前未填写就诊人信息，也可在此处补充；操作完成后点击“完成预约”</span
                    >
                  </p>
                  <p class="MsoNormal">
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      >在“预约详情”界面，核对预约信息是否有误，如存在问题，可点击“取消挂号”完成退号；如无问题请点击“立即支付”按钮完成挂号费用支付，如15分钟内不支付挂号费用，您的预约会被自动取消</span
                    >
                  </p>
                  <p class="MsoNormal">
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      ><br />
                    </span>
                  </p>
                  <p class="MsoNormal" style="text-align:center;">
                    <img
                      src="../images/u5e707093272e2.png"
                      alt=""
                    />
                  </p>
                  <p class="MsoNormal" style="text-align:center;">
                    <br />
                  </p>
                  <p class="MsoNormal">
                    <span
                      style="font-family:Arial;color:#000000;font-size:16px;line-height:2;"
                      >支付完成后系统会出现支付成功的字样，点击</span
                    ><span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      >“完成”可获取报到二维码</span
                    >
                  </p>
                  <p class="MsoNormal">
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      ><br />
                    </span>
                  </p>
                  <p class="MsoNormal" style="text-align:center;">
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      ><img
                        src="../images/u5e7070aa0a973.png"
                        alt=""
                      /><br />
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div v-if="radioValue == 6" class="inner">
              <div class="box2">
                <div class="tit2">
                  <span class="s1">5.取消预约</span>
                </div>
                <div class="content">
                  <p class="MsoNormal">
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      >路径1：预约详情页，可直接点击“取消挂号”完成退号</span
                    >
                  </p>
                  <p class="MsoNormal">
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      >路径2：支付完成后，在“就诊报到”界面，可直接点击“取消挂号”完成退号</span
                    >
                  </p>
                  <p class="MsoNormal">
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      >路径3：通过“首页-就诊服务-就诊”路径进入就诊任务面板，在已创建的就诊流程上，点击“取消挂号”完成退号</span
                    >
                  </p>
                  <p class="MsoNormal">
                    <br />
                  </p>
                  <p class="MsoNormal" style="text-align:center;">
                    <img
                      src="../images/u5e7070dda030b.png"
                      alt=""
                    /><span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                    ></span>
                  </p>
                  <p class="MsoNormal" style="text-align:center;">
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      ><br />
                    </span>
                  </p>
                  <p class="MsoNormal">
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      >路径4：通过“首页-就诊服务-服务-预约记录”路径进入预约记录界面，点击需要退号的就诊流程，在预约详情界面，点击“取消挂号”完成退号</span
                    >
                  </p>
                  <p class="MsoNormal">
                    <span
                      style="color:#000000;font-size:16px;font-family:Arial;line-height:2;"
                      >退号即时生效，已支付的挂号费会在1-3个工作日以内返回您的原账户</span
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "hospital-otherBook-hf",
  data() {
    return Object.assign(
      {
        radioValue: 1
      }
    );
  },
  mounted() {
    console.log("进入预约组件");
  },
  methods: {
    tabClick(value) {
      this.radioValue = value;
      this.radioValueChange(value);
      console.log("tabClick--------------------------", value);
    },
    radioValueChange(value) {
      // if (this.radioValue == 1) {
      //   document.querySelector(".a1").className = "a1 item now";
      //   document.querySelector(".a2").className = "a2";
      // } else {
      //   document.querySelector(".a2").className = "a2 now";
      //   document.querySelector(".a1").className = "a1";
      // }
      let select = ".a" + value;
      for (let i = 1; i <= 6; i++) {
        let removeNow = ".a" + i;
        if (i == value) {
          // document.querySelector(select).className = "a1 item now";
          document.querySelector(select).classList.add("now");
        } else {
          document.querySelector(removeNow).classList.remove("now");
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.guahaopage1 {
  // padding-top: 85px;
  padding-bottom: 125px;
  .title1 {
    text-align: center;
    font-size: 30px;
  }
  .pubctabs1 {
    padding-top: 50px;
    display: flex;
  }
  .pubctabs1 a:first-child {
    margin-left: 0;
  }
  .pubctabs1 a {
    // float: left;
    // width: 232px;
    width: 18%;
    height: 57px;
    line-height: 57px;
    font-size: 18px;
    margin-left: 17px;
    text-align: center;
    box-shadow: 0px 1px 12px 0px #ccc;

    text-decoration: none;
    color: inherit;
  }
  .pubctabs1 a.now {
    background: #0078d4;
    color: #fff;
  }
}

.guahao5page1 {
  margin-top: 33px;
  .item.now {
    background: #0078d4 url(../images/guahao5page1.png) no-repeat 3px center;
  }
  .leftbox {
    width: 286px;
    box-shadow: 0px 1px 12px 0px #ccc;
    // height: 390px;
    float: left;
    margin-right: 10px;
    .item:first-child {
      border-top: 0;
    }
    .item.now {
      background-color: #0078d4;
      a {
        color: #fff;
      }
      a:before {
        border-color: #fff;
      }
    }
    .item {
      padding: 0 20px;
      .li {
        padding: 12px 0;
        border-bottom: 1px dashed #dedede;
      }
      a:before {
        content: "";
        display: block;
        position: absolute;
        border-radius: 50%;
        width: 7px;
        height: 7px;
        border: 3px solid #cbcbcb;
        top: 6px;
        left: 1px;
      }
      a {
        padding-left: 26px;
        display: block;
        font-size: 16px;
        color: #333;
        position: relative;
      }
    }
  }

  .mCustomScrollBox {
    position: relative;
    overflow: hidden;
    height: 100%;
    max-width: 100%;
    outline: none;
    direction: ltr;
  }
  .mCSB_inside > .mCSB_container {
    margin: 0;
  }

  .mCSB_scrollTools {
    width: 8px;
    .mCSB_draggerContainer {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      height: auto;
    }
    .mCSB_dragger {
      cursor: pointer;
      width: 100%;
      height: 30px;
      z-index: 1;
    }

    .mCSB_draggerRail {
      width: 8px;
      background: #cccccc;
      border-radius: 0;
    }
  }

  .rightbox {
   box-shadow: 0px 1px 12px 0px #ccc;
    overflow: hidden;
    margin-top: 7px;
    .inner:first-child {
      display: block;
    }
    .inner {
      padding: 30px;
      display: none;
    }

    .box2 {
      padding-bottom: 40px;
    }

    .tit2 {
      font-size: 20px;
      border-bottom: 1px solid #dbdbdb;
      padding-bottom: 19px;
      position: relative;
      .s1 {
        height: 38px;
        line-height: 38px;
      }
    }
    .tit2:after {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      bottom: -2px;
      height: 3px;
      background: #0078d4;
      width: 60px;
    }

    .content {
      line-height: 22px;
      color: #707070;
      padding-top: 22px;
      img {
        display: initial;
      }
    }
  }
}

.m-screen-pc {
}

.m-screen-mobile {
  .guahaopage1{
    .title1 {
        font-size: 0.4rem;
    }
    .pubctabs1 {
        padding-top: 0.4rem;
        white-space: nowrap;
        overflow-x: auto;
    }
    .pubctabs1 a {
        float: none;
        display: inline-block;
        width: 2.6rem;
        width: 20%;
        height: 0.8rem;
        line-height: 0.8rem;
        font-size: 0.26rem;
        margin-left: 0.1rem;
    }
  }

  .guahao5page1 {
    margin-top: 0.4rem;
    .leftbox {
        width: auto;
        float: none;
        padding: 0 0 0.2rem;
        margin: 0;
        // height: 5rem;
        .item {
            padding: 0 0.3rem;
            .li {
                padding: 0.2rem 0;
            }
            a {
                font-size: 0.28rem;
                padding-left: 0.3rem;
            }
            a:before {
                width: 0.2rem;
                height: 0.2rem;
                border-width: 0.05rem;
                top: 0.1rem;
            }
        }
    }

    .rightbox {
        margin-top: 0.2rem;
        .inner {
            padding: 0.3rem;
        }
        .box2 {
            padding-bottom: 0.4rem;
        }
        .tit2 {
            font-size: 0.3rem;
            padding-bottom: 0.3rem;
            .s1 {
                height: 38px;
                line-height: 38px;
            }
        }
        .content {
            line-height: 1.6;
            img {
              width: 100%;
            }
        }
    }
  }
  .x-wrap {
    width: auto;
    padding: 0 0.25rem;
  }

}
</style>
